var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Button, IconButton, translate, XCloseIcon, } from '@lucidlink/uicore';
import { PII_MASK_CLASS } from '#constants';
import { useOpenGuestDetailsDrawer } from '../../../../hooks/useOpenGuestDetailsDrawer';
import { GuestsTabTestIdFactory } from './interactions';
export const GuestEntry = ({ email, filespaceId, isOptimistic = false, onRemove, workspaceId, }) => {
    _react_refresh_temp_2();
    const { isPending, mutate: openGuestDetails } = useOpenGuestDetailsDrawer({
        filespaceId,
        workspaceId,
    });
    return (_jsxs(Box, { align: "center", padding: "xs sm", children: [_jsxs(Box, { align: "center", gap: "s", grow: 1, children: [_jsx(Avatar, { "data-testid": "created-by-avatar", id: email, size: "small", value: email }), _jsx(Button, { className: PII_MASK_CLASS, "data-testid": GuestsTabTestIdFactory.getOpenGuestDetailsTestId(email), disabled: isOptimistic || isPending, kind: "link", onClick: () => openGuestDetails(email), children: email })] }), _jsx(IconButton, { "aria-label": translate('Remove guest {{email}}', { email }), "data-testid": "remove-guest-button", Icon: XCloseIcon, isLoading: isOptimistic, kind: "ghost", onClick: onRemove, tooltipText: translate('Remove guest') })] }));
};
_react_refresh_temp_1 = GuestEntry;
$RefreshReg$(_react_refresh_temp_1, "GuestEntry");
_react_refresh_temp_2(GuestEntry, "TkWBWzBcIbgPCV4G4I09UdUmVKQ=", false, () => [useOpenGuestDetailsDrawer]);
